var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-box"},[_c('i',{staticClass:"background",style:({width: (_vm.step/_vm.total).toFixed(4)*100 + '%'})}),_c('span',[_vm._v(_vm._s(_vm.step)+" of "+_vm._s(_vm.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }